import React, { useState, useMemo, useEffect } from 'react';
import { Box, Tab, Tabs, Tooltip } from '@mui/material';
import { toast } from 'react-toastify';

import Swal from 'sweetalert2';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import useStore from '../../states/store';
import TabPanel from '../../components/TabPanel';
import useCWPContext from './context/useCWPContext';
import { DashboardProvider } from '../Dashboard/useDashboard';
import Filter from './components/Filter';
import Table from './components/Table';
import AppointmentCalendar from '../../components/AppontmentCalendar';
import CwpDetailsModal from './components/CwpDetailsModal';
import {
  postCwpApprovalList,
  postCwpApprovalDetail,
  postCwpApprovalCalendar,
  postApprovaltUpdateStatus,
} from '../../api/cwpMaintenance';

export default function CWPApproval() {
  const auth = useStore((state) => state.auth);
  const date = new Date();
  const monthsOptions = [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];
  const yearOptions = [];

  /* eslint-disable no-plusplus */
  for (let i = 2010; i <= date.getFullYear(); i++) {
    yearOptions.push({ label: i.toString(), value: i.toString() });
  }

  let departmenDefaulttFilter = null;
  if (auth.designation === 'admin') {
    departmenDefaulttFilter = { label: 'ALL', value: null };
  } else if (auth.designation === 'KASM' || auth.designation === 'KASS') {
    departmenDefaulttFilter = { label: 'KASD', value: 'KASD' };
  } else if (
    auth.designation === 'SAM' ||
    auth.designation === 'SAR' ||
    auth.designation === 'SAS'
  ) {
    departmenDefaulttFilter = { label: 'SALES', value: 'SAR' };
  }

  const defaultFilter = {
    department: departmenDefaulttFilter,
    manager: { label: 'ALL', value: null },
    kasssar: { label: 'ALL', value: null },
    month: monthsOptions[date.getMonth()],
    year: { label: date.getFullYear().toString(), value: date.getFullYear().toString() },
  };

  const [activeTab, setActiveTab] = useState(0);
  const [filterForm, setFilterForm] = useState(defaultFilter);
  const [rowsSelected, setRowsSelected] = useState([]);
  const [cwpData, setCwpData] = useState([]);
  const [cwpDetails, setCwpDetails] = useState({ toggle: false, data: [] });
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clearFilter, setClearFilter] = useState(false);

  const [calendarParams, setCalendarParams] = useState({
    date_month: `${date.getFullYear()}-${filterForm?.month?.value}`,
    data: [],
    date: '',
    rep_id: '',
    manager_ids: [],
    loading: false,
  });

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const searchCwp = async () => {
    try {
      let tabstatus = null;
      if (activeTab === 0) {
        tabstatus = 2;
      } else if (activeTab === 1) {
        tabstatus = 1;
      } else {
        tabstatus = 3;
      }

      setLoading(true);
      setCalendarParams({
        ...calendarParams,
        loading: true,
      });
      const statusType = {
        department: filterForm?.department?.value,
        manager_id: auth.user_id,
        rep_id: filterForm?.kasssar?.value,
        month: [filterForm?.month?.value],
        status: [tabstatus],
      };
      const response = await postCwpApprovalList(statusType);
      const calendar = await postCwpApprovalCalendar({ ...statusType, date_submitted: null });
      const { code, data } = response.data;

      if (code === '200') {
        setCwpData(data);
        setCalendarData(calendar?.data?.data);

        setCalendarParams({
          ...calendarParams,
          loading: false,
          date_month: `${date.getFullYear()}-${filterForm?.month?.value}`,
          data: calendar?.data?.data.map((row) => ({
            date: row.from,
            count: row.point_person_count.toString(),
            label: row.point_person_count > 0 ? row.point_person_count.toString() : '',
            html: (
              <Tooltip title={row.point_person_name} className='ewde-tooltip' arrow>
                <span>{row.point_person_count > 0 ? row.point_person_count.toString() : ''}</span>
              </Tooltip>
            ),
          })),
        });
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const clearCwp = () => {
    setFilterForm(defaultFilter);
    setClearFilter(true);
  };

  const handleViewAppointments = async (id) => {
    try {
      setCwpDetails({ toggle: false, data: [] });
      toast.loading('requesting data please wait');

      const response = await postCwpApprovalDetail({ appointment_id: id });

      if (response.data.code === '200') {
        const details = response?.data?.data.map((row) => ({
          ...row,
          status_id: 0,
        }));

        setCwpDetails({ toggle: true, data: details });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleViewCalendar = async (item) => {
    try {
      setCalendarParams({
        ...calendarParams,
        loading: true,
      });
      toast.loading('requesting data please wait');

      let tabstatus = null;
      if (activeTab === 0) {
        tabstatus = 2;
      } else if (activeTab === 1) {
        tabstatus = 1;
      } else {
        tabstatus = 3;
      }

      const statusType = {
        department: filterForm?.department?.value,
        manager_id: auth.user_id,
        rep_id: item.rep_id,
        date_submitted: item.date_submitted,
        month: [filterForm?.month?.value],
        status: [tabstatus],
      };
      const response = await postCwpApprovalCalendar(statusType);
      const { code, data } = response.data;
      if (code === '200') {
        setCalendarData(data);

        setCalendarParams({
          ...calendarParams,
          loading: false,
          date_month: `${date.getFullYear()}-${filterForm?.month?.value}`,
          data: response?.data?.data.map((row) => ({
            date: row.from,
            count: row.point_person_count.toString(),
            label: row.point_person_count > 0 ? row.point_person_count.toString() : '',
            html: (
              <Tooltip title={row.point_person_name} className='ewde-tooltip' arrow>
                <span>{row.point_person_count > 0 ? row.point_person_count.toString() : ''}</span>
              </Tooltip>
            ),
          })),
        });
      }

      toast.dismiss();
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleUpdateAll = (status = null, isall = null) => {
    const statusText = status === 1 ? 'approved all appointments?' : 'reject all appointments?';
    Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${
        isall === true ? statusText : 'submit the approvals of the selected appointments?'
      }`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '<small style="color:#fff"> Confirm </small>',
      cancelButtonText: '<small style="color:#fff"> Cancel </small>',
    }).then((response) => {
      if (response.isConfirmed) {
        const mergeArray = [];
        const sampleArray = rowsSelected?.map((item) => item.appointment_id.split(',').concat());
        const rowIds = mergeArray
          .concat(...sampleArray)
          .map((item) => ({ appointment_id: item, approval_id: status }));

        const cwpDetailsForm =
          isall === true
            ? {
                designation: auth.designation,
                data: rowIds,
              }
            : {
                designation: auth.designation,
                data: cwpDetails?.data
                  ?.filter((item) => item.status_id !== 0)
                  .map((item) => ({
                    appointment_id: item.appointment_id,
                    approval_id: item.status_id,
                  })),
              };
        try {
          postApprovaltUpdateStatus(cwpDetailsForm).then((res) => {
            const { code, message } = res.data;
            if (code === '200') {
              setCwpDetails({ toggle: false, data: [] });
              toast.success(message);
              searchCwp();
            }
          });
        } catch (error) {
          toast.error(error.message);
        }
      }
    });
  };

  const handleCwpDetailStatus = (e, status, row) => {
    if (e.target.checked) {
      if (status === 1) {
        document.getElementById(`${row.id}-status-reject`).checked = false;
      } else {
        document.getElementById(`${row.id}-status-approve`).checked = false;
      }
    }

    const details = {
      ...cwpDetails,
      data: cwpDetails?.data?.map((item) =>
        item.id === row.id ? { ...item, status_id: e.target.checked ? status : 0 } : item,
      ),
    };
    setCwpDetails(details);
  };

  const handleUpdateCwpAppointment = () => {
    handleUpdateAll(null, null);
  };

  useEffect(() => {
    searchCwp();
  }, [activeTab, clearFilter]);

  return (
    <DashboardProvider>
      <useCWPContext.Provider
        value={useMemo(
          () => ({
            auth,
            activeTab,
            cwpData,
            cwpDetails,
            calendarData,
            rowsSelected,
            calendarParams,
            setCwpDetails,
            setFilterForm,
            setRowsSelected,
            setCalendarParams,
            filterForm,
            monthsOptions,
            yearOptions,
            searchCwp,
            clearCwp,
            loading,
            handleUpdateAll,
            handleViewAppointments,
            handleViewCalendar,
            handleCwpDetailStatus,
            handleUpdateCwpAppointment,
          }),
          [filterForm, cwpData, loading, cwpDetails.toggle, cwpDetails, rowsSelected],
        )}
      >
        <div className='body-content'>
          <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
            <Filter />
          </Box>
          <Box padding={4}>
            <Box>
              <Box>
                <Grid container spacing={2}>
                  <Grid xs={12} sm={12} md={12}>
                    <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                          value={activeTab}
                          onChange={handleChangeActiveTab}
                          aria-label='basic tabs example'
                        >
                          <Tab
                            label='For Approval'
                            id='cwp-for-approval'
                            aria-controls='cwp-for-approval'
                          />
                          <Tab label='Approved' id='cwp-approved' aria-controls='cwp-approved' />
                          <Tab label='Rejected' id='cwp-rejected' aria-controls='cwp-rejected' />
                        </Tabs>
                      </Box>
                      <TabPanel value={activeTab} index={activeTab}>
                        {activeTab === 0 ? (
                          <Grid container spacing={2}>
                            <Grid md={8}>
                              <Table />
                            </Grid>

                            <Grid md={4}>
                              <AppointmentCalendar
                                // initDate={moment().format('YYYY-MM-DD')}
                                appointments={calendarParams.data}
                                initDate={calendarParams.date_month}
                                className='ec-container-centered'
                                isDisableNavigation
                                loading={calendarParams.loading}
                              />
                            </Grid>
                          </Grid>
                        ) : (
                          <Table />
                        )}
                      </TabPanel>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </div>
        <CwpDetailsModal />
      </useCWPContext.Provider>
    </DashboardProvider>
  );
}
